module.exports = __webpack_public_path__ + "static/media/spirit-hero.fd273d9d.png";